enum ExperienceType {
    VARILUX = 'varilux'
}

export default ExperienceType;